import AppShell from "./AppShell";
import { getApp } from "@/lib/apps";

const Deafwav = () => <AppShell app={getApp("deafwav")} />;

export default Deafwav;
